import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { SubfeeAction, useSubfeeProvider } from '../Subfee.Hooks';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function SubfeeList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useSubfeeProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.tiers}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.code}</th>
          <th>{lang.name}</th>
          <th>{lang.documents}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: subfee }) => (
            <tr key={subfee.id}>
              <td>
                <b>{subfee.code}</b>
              </td>
              <td>{subfee.name}</td>
              <td>
                {subfee.documents?.length > 0
                  ? `${subfee.documents.length} ${lang.document}(s)`
                  : lang.noDocumentsUploaded}
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <DropdownButton
                    buttonMedia={<Icon class="fas-download" />}
                    horizontalPosition="auto_fixed"
                    verticalPosition="auto_fixed"
                    subcomponents={ThemeDropdownButtonPopup}
                    disabled={!subfee.documents?.length}
                    htmlElementProps={{ title: lang.download }}
                    active
                    dropdownOptions={
                      <DataMap
                        data={subfee.documents}
                        render={({ data: doc }) => (
                          <Button
                            key={doc.id}
                            class={ThemeButtonMenuItem}
                            style={{ buttonText: { textTransform: 'unset' } }}
                            url={doc.mediaFile.url}
                            media={<Icon class="fas-download" />}
                            target="_blank"
                            children={doc.mediaFile.name}
                            htmlElementProps={{ title: lang.download }}
                          />
                        )}
                      />
                    }
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: subfee.id.toString(),
                      action: SubfeeAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_SUBFEE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: subfee.id.toString(),
                      action: SubfeeAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_SUBFEE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
